import gtn from './GTNexus.Common';
/*
    Code here for
        Sign up jade
        Ask-An-Evangelist
        Admin Site
 */
'use strict';
window.onLoadSignup = function(csrf){
    var ui_csrf = csrf;

    $('#country').dropdown({
        source: function (response) {
            $.getJSON('/javascripts/countries.json', function (data) {
                //In this example the Structure the data with val, label syntax is done on the server
                //{value: 'AL', label:'Alabama'}
                response(data);
            });
        }
    })

    // Copy the tooltip setting to the new combo box.
    $("#country").closest(".k-combobox").attr("data-tooltip", $("#country").attr("data-tooltip"));

    // Initialize the tooltips.
    var tooltip = $(".signup-section").kendoTooltip({
        filter: "[data-tooltip]",
        content: kendo.template("#=target.data('tooltip')#"),
        width: 250,
        position: "right"
    }).data("kendoTooltip");

    $(".signup-section [data-tooltip]").focus(function () {
        tooltip.show($(this));
    }).blur(function () {
        tooltip.hide();
    });

    $(".appx-agreement").click(function () {
        var htmlStr = '<iframe src="/user/assets/infor-nexus-developer-network-TOS" />';
        $('body').message({
            title : 'Appx Agreement',
            message : htmlStr,
            cssClass : 'terms-modal',
            buttons: [{
                text: 'Close',
                click: function () {
                    $(this).modal('close');
                },
                isDefault: true
            }]
        })
    });

    $("#username").focus();
    $('#createAccount').click( function(e){
        $('.button-line').busyindicator({ text : 'Completing Sign up...' , displayDelay : 0 }).trigger('start.busyindicator');
        $.post(location.href ,
            {
                _csrf: ui_csrf,
                firstName : $('#firstName').val(),
                lastName : $('#lastName').val(),
                email : $('#email').val(),
                email2 : $('#email2').val(),
                organization : $('#organization').val(),
                jobTitle : $('#jobTitle').val(),
                progLangs : $('#progLangs').val(),
                country : $('#country').val(),
                agreement : $('#agreement').val(),
                'g-recaptcha-response': $('#g-recaptcha-response').val()
            } , 'json')
            .done(function () {
                gtn.ui.displaySuccessMessage('Sign Up Complete', 'You have signed up successfully. You will soon receive an e-mail with detailed information on how to access your sandbox environment.',
                    function () {
                        location.href = '/';
                    })
            })
            .fail(function (jqXHR) {
                var response = jqXHR.responseJSON;
                if (response && response.errors) {
                    gtn.ui.displayUserErrors(response.errors);
                } else {
                    gtn.ui.displayUserErrors([{message: 'Unknown Error - Please alert the Evangelism team at Infor Nexus'}]);
                }
            })
            .always(function () {
                $('.button-line').busyindicator().trigger('updated.busyindicator');
            })
    })
};

gtn.ui.initializeAceEditorPane = function() {
    var containers = document.getElementsByClassName('tab-panel');
    gtn.ui.aceEditorFocusOut = (e) => {
        for(var tabPanel of containers) {
            tabPanel.classList.remove('gtn-onFocus');
        }
    }
    gtn.ui.aceEditorFocus = (e) => {
        for(var tabPanel of containers) {
            tabPanel.classList.add('gtn-onFocus')
        }
    }
}
function initializeAceEdit(id, mode) {
    if(! gtn.ui.aceEditorFocusOut ) {
        gtn.ui.initializeAceEditorPane();
    }
    var aceEdit = ace.edit(id);
    aceEdit.getSession().setMode(mode);
    aceEdit.session.setUseWorker(false);
    aceEdit.on('focus', gtn.ui.aceEditorFocus);
    aceEdit.on('blur', gtn.ui.aceEditorFocusOut);
    return aceEdit;
}

window.onLoadAskAnEvangelist = function(csrf){
    var ui_csrf = csrf;

    $('#topic').dropdown({
        source: function (response) {
            $.getJSON('/javascripts/website-topics.json', function (data) {
                //In this example the Structure the data with val, label syntax is done on the server
                //{value: 'AL', label:'Alabama'}
                response(data);
            });
        }
    })
    $('.tab-container').tabs();

    $('#submitQuestion').click(function(e){
        $('.button-line').busyindicator({
            text: 'Submitting Question...',
            displayDelay: 0
        }).trigger('start.busyindicator');
        var payload = {
            _csrf: ui_csrf,
            name: $('#firstName').val() + " " + $('#lastName').val(),
            topic: $('#topic').val(),
            email: $('#email').val(),
            question: $('#question').val(),
            html: hEditor.getValue(),
            javascript: jEditor.getValue(),
            referral_url : document.referrer,
            json: jsonEditor.getValue(),
            'g-recaptcha-response': $('#g-recaptcha-response').val()
        }
        $.post('/user/ask-an-evangelist', payload , "json")
            .done(function(){
                gtn.ui.displaySuccessMessage('Question Submitted' , 'Your question has been emailed to a Infor Nexus Evangelist. You should receive a response by the end of the next business day. Thanks for contributing to the AppXpress Community' ,
                    function(){
                        window.history.go(-1);
                    }
                )
            })
            .fail(function(res){
                var response = res.responseJSON;
                if( response && response.errors ){
                    gtn.ui.displayUserErrors( response.errors );
                } else{
                    gtn.ui.displayUserErrors( [{ message : 'Unknown Error - Please alert the Evangelism team at Infor Nexus'}]);
                }
            })
            .always(function(){
                $('.button-line').busyindicator().trigger('updated.busyindicator');
            })
    })


    // Initialize the tooltips.
    var tooltip = $(".article-content").kendoTooltip({
        filter: "[data-tooltip]",
        content: kendo.template("#=target.data('tooltip')#"),
        width: 250,
        position: "right"
    }).data("kendoTooltip");

    $(".article-content [data-tooltip]").focus(function () {
        tooltip.show($(this));
    }).blur(function () {
        tooltip.hide();
    });
    var hEditor = initializeAceEdit("htmlEditor", "ace/mode/html");
    var jEditor = initializeAceEdit('jsEditor', "ace/mode/javascript");
    var jsonEditor = initializeAceEdit("jsonEditor", 'ace/mode/json');
}

gtn.admin = {};
/*
 Show a popup on the screen that displays the user errors
 ServerErrors should be an array of errors with a message field to alert the user
 */
gtn.ui.displayUserErrors = function( serverErrors ){
    var htmlString = 'Form has the following errors:<ul>';
    if(serverErrors){
        serverErrors.forEach(function(item){
            htmlString += '<li>' + item.message + '</li>';
        });
    }else { console.err('Display User Errors function requires an array of error with messages'); }
    htmlString += '</ul>';
    $('body').message({
        title : 'Form Submission Error',
        message : htmlString ,
        isError : true,
        buttons : [{
            text : 'Ok',
            click : function() { $(this).modal('close'); },
            isDefault : true
        }]
    })
};
/*
 Display a success message
 Optionally, display a success title - default will be Success
 Optionally, add a redirectUrl - if added, will redirect the user on close of modal
 */
gtn.ui.displaySuccessMessage = function( successTitle , successMsg , closeFn ){
    $('body').message({
        title : successTitle ? successTitle : 'Success',
        isSuccess : true,
        message : successMsg ? successMsg : 'Form submission successful',
        buttons : [{
            text : 'Ok',
            click : function(){
                $(this).modal('close');
                if( closeFn ){
                    closeFn();
                }
            },
            isDefault : true
        }]
    })
};

gtn.admin.populateQuestionIntoDOM = function(doc){
    var $div = $('#questiondiv').show();
    gtn.admin.sendToEmail = doc.email ;

    $('#nameValue').text( doc.name );
    $('#topicValue').text( doc.topic );
    $('#questionValue').text( doc.question );
    $('#readyState').val( doc.ready ).trigger('updated');
    $('#subtopic').val( doc.subtopic );
    $('#answer').val( doc.answer );
    if( doc.tags ){
        $('#questionTags').val( doc.tags ).trigger('updated');
    } else{
        $('#questionTags').val([]).trigger('updated');
    }


    ace.edit("htmlEditor").setValue( doc.answerHtml , 1);
    ace.edit('jsEditor').setValue( doc.answerJavascript , 1);
    ace.edit('jsonEditor').setValue( doc.answerJson , 1);

    //IF question already answered, alert USER
    if( doc.ready == 0 ){
        gtn.admin.sendEmailOnSubmit = true;
    }else {
        var $msg = $('<p/>').addClass('m-page-summary-alert').html(' <b>Alert</b> : Question has already been answered. You can edit the answer' +
            ' to the question. Press SAVE at the button to save your changes. Be aware that an email will NOT be resent.');
        $div.prepend($msg);
        //Change label of submit button to
        $('#submitQuestion').val('SAVE');
        gtn.admin.sendEmailOnSubmit = false ;
    }

    var $codeDiv = $('#questionCodeSnippets');
    if( doc.javascriptCode && doc.javascriptCode != ""){
        var $jsHeader = $('<h4/>').text('Javascript Code');
        var $codeBlock = $('<pre\>');
        var $jsCode = $('<code/>').addClass('language-javascript').append( doc.javascriptCode );
        $codeBlock.append( $jsCode );
        $codeDiv.append($jsHeader).append($codeBlock);
    }
    if( doc.htmlCode && doc.htmlCode != ""){
        var $htmlHeader = $('<h4/>').text('Markup Code');
        var $htmlCodeBlock = $('<pre\>');
        var $htmlCode = $('<code/>').addClass('language-markup').text( doc.htmlCode );
        $htmlCodeBlock.append( $htmlCode );
        $codeDiv.append($htmlHeader).append($htmlCodeBlock);
    }
    if( doc.jsonCode && doc.jsonCode != "" ) {
        var $jsonHeader = $('<h4/>').text('JSON');
        var $jsonCodeBlock = $('<pre\>');
        var $jsonCode = $('<code/>').addClass('language-json').text(doc.jsonCode);
        $jsonCodeBlock.append($jsonCode);
        $codeDiv.append($jsonHeader).append($jsonCodeBlock);
    }

    Prism.highlightAll();
};

gtn.admin.editForumQuestionInit = function(){
    $('#topic').dropdown({
        source : function(response){
            $.getJSON('/javascripts/website-topics.json' , function(topics){
                response(topics);
            })
        }
    });

    $('#searchBtn').click(function(){
        $('table > tbody').empty();
        $.get('/user/mongo/GetQuestions', {
            topic: $('#topic').val() ,
            keywords: $('#keywords').val(),
            offset: 0,
            limit: 20,
            admin : true
        })
            .done(function (data) {
                gtn.admin.populateAdminLookupTable(data);
            });
    })
};

gtn.admin.answerQuestionInit = function( csrf ){
    $(".tab-container").tabs();

    $('#submitQuestion').click(function(e){
        var payload = {
            _csrf: csrf,
            subtopic: $('#subtopic').val(),
            answer: $('#answer').val(),
            ready: $('#readyState').val(),
            html: hEditor.getValue(),
            question: $('#questionValue').text(),
            javascript: jEditor.getValue(),
            json: jsonEditor.getValue(),
            id: gtn.admin.questionId,
            sendEmail: gtn.admin.sendEmailOnSubmit,
            name: $('#nameValue').text(),
            email: gtn.admin.sendToEmail,
            tags : JSON.stringify( $('#questionTags').val() )
        }

        $.post('/admin/mongo/saveQuestionAnswer', payload, "json")
            .done(function(){
                console.log('success')
                //Open popover
                gtn.ui.displaySuccessMessage('Question Submitted','Question was successfully answered and saved to database', function () {
                    $('.m-page-summary-alert').remove();
                    $('#questiondiv').hide();
                });
            })
            .fail(function(xhr, status , err ){
                if(xhr.responseJSON){
                    var errors = xhr.responseJSON.errors
                    gtn.ui.displayUserErrors( xhr.responseJSON.errors );
                } else {
                    alert('ERROR ON SERVER !');
                }
            })
    })

    var hEditor = initializeAceEdit("htmlEditor", "ace/mode/html");
    var jEditor = initializeAceEdit('jsEditor', "ace/mode/javascript");
    var jsonEditor = initializeAceEdit("jsonEditor", 'ace/mode/json');

    $("#findQuestionBtn").click( function(){
        gtn.admin.questionId = $('#questionId').val()
        $('.m-loading-spinner').show();
        $('#questionCodeSnippets').empty();
        $.get('/admin/mongo/fetchQuestionById', {
            id : gtn.admin.questionId
        }).done(function(document){
            console.log('success');
            console.log(document);
            //gtn.page.addQuestionHtml(document);
            gtn.admin.populateQuestionIntoDOM(document);
        })
            .fail(function(){
                alert("Couldn't find a question with this ID")
            })
            .always(function(){
                $('.m-loading-spinner').hide();
            });
    });

    $('#readyState').dropdown();
    $('#questionTags').multiselect({
        source : function(setFn){
            $.getJSON('/javascripts/question-tags.json' , function(tags){
                setFn(tags);
            })
        }
    }).trigger('load.dropdown.source');

    var id = location.search.split('id=')[1];
    if (id) {
        $('#questionId').val(id);
        $('#findQuestionBtn').click();
    }
}


gtn.admin.populateAdminLookupTable = function(data){
    var $table = $('table');
    var $tr,$td;
    data._result.forEach(function(item,indx){
        $tr = $('<tr/>');
        $td = $('<td/>').html('<a href="/admin/answer-forum-question?id=' + item._id + '">Link</a>');
        $tr.append($td);
        $td = $('<td/>').text(item.subtopic);
        $tr.append($td);
        $td = $('<td/>').text(item.question);
        $tr.append($td);
        $table.append($tr);
    });
};

window.gtn_admin = gtn.admin;


// WEBPACK FOOTER //
// ./public/javascripts/GTNexus.Admin.js